import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
} from 'react';
import { Prototype } from './types';

type PrototypeInformationGraph = {
  prototype: Prototype;
  visibleBusinessConcepts: string[];
  setVisibleBusinessConcepts: Dispatch<SetStateAction<string[]>>;
  visibleDataSources: string[];
  setVisibleDataSources: Dispatch<SetStateAction<string[]>>;
};

const defaultPrototypeInformationGraphContext = null;

export const PrototypeInformationGraphContext =
  createContext<PrototypeInformationGraph | null>(
    defaultPrototypeInformationGraphContext,
  );

export const usePrototypeInformationGraphContext = () => {
  const contextValue = useContext(PrototypeInformationGraphContext);

  if (!contextValue) {
    throw new Error(
      'usePrototypeInformationGraphContext has to be used within <PrototypeInformationGraphContext.Provider>',
    );
  }

  return contextValue;
};

export const PrototypeInformationGraphContextProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: PrototypeInformationGraph;
}) => {
  return (
    <PrototypeInformationGraphContext.Provider value={value}>
      {children}
    </PrototypeInformationGraphContext.Provider>
  );
};
